export default "<div class=\"lds-ellipsis\"><div></div><div></div><div></div><div></div></div>\n"